import React, { Suspense, useEffect, useRef } from 'react';
import { useDispatch } from 'react-redux';
import { SearchProvider } from './context/search/useSearch';
import CONSTANTS from './_constants';
import PortalLoader from './components/PortalLoader';
import { Toast } from './components/portals/Toast';
import { useCart } from './hooks/useCart';
// import { SearchProvider } from './context/search/useSearch';

import LoadingBar from './components/portals/LoadingBar';
import LoadingIcon from './components/portals/MiniCart/Loading';

import CartCountBadge from './components/portals/CartCountBadge';
// import RecentlyViewed from './components/portals/RecentlyViewed/index';
import { dispatchToast } from './store/actions/toast';

import CountdownTimer from './components/portals/CountdownTimer';
import DeliveryPromise from './components/portals/DeliveryPromise';
import DeliveryPromiseUSA from './components/portals/DeliveryPromiseUSA';
import VoyadoRecommendations from './components/portals/VoyadoRecommendations';
import { elevateFetchShim } from './context/search/services/Voyado/helpers/elevateFetchShim';
import { setupCustomerKeySync } from './context/search/services/Voyado/helpers/voyadoHelpers';
import { localStorageBackedSession } from '@apptus/esales-api';
import MiniCart from './components/portals/MiniCart/index';
import QuickAdd from './components/portals/QuickAdd/index';
// import VoyadoRecommendations from './components/portals/VoyadoRecommendations';

import SearchInput from './components/portals/Search/SearchInput';
import SearchResultsTrending from './components/portals/Search/SearchResultsTrending';
import SearchSubmit from './components/portals/Search/SearchSubmit';
import SearchNoResults from './components/portals/Search/SearchNoResults';
import SearchResultsSuggestions from './components/portals/Search/SearchResultsSuggestions';
import SearchAmendedResults from './components/portals/Search/SearchAmendedResults';
import SearchDidYouMean from './components/portals/Search/SearchDidYouMean';
import SearchResultsCollections from './components/portals/Search/SearchResultsCollections';
import SearchResultsPages from './components/portals/Search/SearchResultsPages';
import SearchResultsArticles from './components/portals/Search/SearchResultsArticles';
import SearchResultsProducts from './components/portals/Search/SearchResultsProducts';
import SearchFilterQuickRemoves from './components/portals/Search/SearchFilterQuickRemoves';
import SearchFilters from './components/portals/Search/SearchFilters';
import SearchFilteredProducts from './components/portals/Search/SearchFilteredProducts';
import SearchProductsCount from './components/portals/Search/SearchProductsCount';
import SearchFilterCount from './components/portals/Search/SearchFilterCount';
import SearchSortBy from './components/portals/Search/SearchSortBy';
import JustTheApplyButton from './components/portals/Search/JustTheApplyButton';
import SearchTabs from './components/portals/Search/SearchTabs';
import SearchResultsArticlesPage from './components/portals/Search/SearchResultsArticlesPage';
import SearchResultsContentPages from './components/portals/Search/SearchResultsContentPages';


type AppProps = {
  config: any,
}

export const App: React.FC<AppProps> = ({ config }) => {
  const dispatch = useDispatch();
  const { getCartState, setDOMHelpers, cart, updating } = useCart();
  const prevUpdating = useRef(updating);

  elevateFetchShim()

  useEffect(() => {
    getCartState()
  }, []);

  useEffect(() => {
    // Setup listener for customerKey updates from Liquid script
    setupCustomerKeySync(localStorageBackedSession);
  }, []);

  useEffect(() => {
    setDOMHelpers()
  },[cart])

  // Dispatch cart update event when cart finishes updating
  useEffect(() => {
    // Only dispatch event when transitioning from updating to not updating
    if (prevUpdating.current === true && updating === false) {
      // Dispatch event after cart has finished updating
      window.dispatchEvent(new CustomEvent('blubolt:cart-updated', {
        detail: { cart }
      }));
    }
    prevUpdating.current = updating;
  }, [updating, cart])

  window['blubolt'].dispatchToast = (type: string, data: any) => dispatch(dispatchToast(type, data));

  const renderPortal = (dataAttr: string, Component: React.ComponentType<any> | React.LazyExoticComponent<any>) => (
    <Suspense fallback={<LoadingIcon />}>
      <PortalLoader dataAttr={dataAttr} Component={Component} />
    </Suspense>
  )

  return (
    <div>
      {renderPortal(CONSTANTS.PORTALS.LOADING, LoadingBar)}
      {renderPortal(CONSTANTS.PORTALS.TOAST, Toast)}
      {renderPortal(CONSTANTS.PORTALS.CART_COUNT_BADGE, CartCountBadge)}
      {/* {renderPortal(CONSTANTS.PORTALS.RECENTLY_VIEWED, RecentlyViewed)} */}
      {renderPortal(CONSTANTS.PORTALS.MINICART, MiniCart)}
      {renderPortal(CONSTANTS.PORTALS.QUICKADD, QuickAdd)}
      {renderPortal(CONSTANTS.PORTALS.TIMER, CountdownTimer)}
      {renderPortal(CONSTANTS.PORTALS.DELIVERY_PROMISE, DeliveryPromise)}
      {renderPortal(CONSTANTS.PORTALS.DELIVERY_PROMISE_USA, DeliveryPromiseUSA)}
      {renderPortal(CONSTANTS.PORTALS.VOYADO_RECOMMENDATIONS, VoyadoRecommendations)}

      { config.appLayerConfigSearch
        && config.appLayerConfigSearchProductsPerPage
        && config.appLayerConfigSearchLoadMoreMode
        && <SearchProvider
          config={{
            ...config.appLayerConfigSearch,
            rProductsPerPage: config.appLayerConfigSearchProductsPerPage,
            rLoadMoreMode: config.appLayerConfigSearchLoadMoreMode,
            searchFilterDummyTag: config.appLayerConfigSearchFilterDummyTag,
            marketsEnabled: config.appLayerConfigMarketsEnabled > 1
          }}
          activeCollection={{
            id: config.appLayerConfigActiveCollectionId ?? null,
            title: config.appLayerConfigActiveCollectionTitle ?? null,
            handle: config.appLayerConfigActiveCollectionHandle ?? null,
          }}>
          {renderPortal(CONSTANTS.PORTALS.SEARCH_INPUT, SearchInput)}
          {renderPortal(CONSTANTS.PORTALS.SEARCH_TRENDING, SearchResultsTrending)}
          {renderPortal(CONSTANTS.PORTALS.SEARCH_SUBMIT, SearchSubmit)}
          {renderPortal(CONSTANTS.PORTALS.SEARCH_NO_RESULTS, SearchNoResults)}
          {renderPortal(CONSTANTS.PORTALS.SEARCH_SUGGESTIONS, SearchResultsSuggestions)}
          {renderPortal(CONSTANTS.PORTALS.SEARCH_COLLECTIONS, SearchResultsCollections)}
          {renderPortal(CONSTANTS.PORTALS.SEARCH_PAGES, SearchResultsPages)}
          {renderPortal(CONSTANTS.PORTALS.SEARCH_ARTICLES, SearchResultsArticles)}
          {renderPortal(CONSTANTS.PORTALS.SEARCH_PRODUCTS, SearchResultsProducts)}
          {renderPortal(CONSTANTS.PORTALS.SEARCH_FILTER_QUICK_REMOVES, SearchFilterQuickRemoves)}
          {renderPortal(CONSTANTS.PORTALS.SEARCH_FILTERS, SearchFilters)}
          {renderPortal(CONSTANTS.PORTALS.SEARCH_FILTERED_PRODUCTS, SearchFilteredProducts)}
          {renderPortal(CONSTANTS.PORTALS.SEARCH_PRODUCTS_COUNT, SearchProductsCount)}
          {renderPortal(CONSTANTS.PORTALS.SEARCH_FILTER_COUNT, SearchFilterCount)}
          {renderPortal(CONSTANTS.PORTALS.SEARCH_SORT_BY, SearchSortBy)}
          {renderPortal(CONSTANTS.PORTALS.SEARCH_TABS, SearchTabs)}
          {renderPortal(CONSTANTS.PORTALS.SEARCH_RESULTS_BLOGS, SearchResultsArticlesPage)}
          {renderPortal(CONSTANTS.PORTALS.SEARCH_RESULTS_CONTENT_PAGES, SearchResultsContentPages)}
          {renderPortal(CONSTANTS.PORTALS.SEARCH_FILTER_JUST_APPLY, JustTheApplyButton)}
          {renderPortal(CONSTANTS.PORTALS.SEARCH_AMENDED_RESULTS, SearchAmendedResults)}
          {renderPortal(CONSTANTS.PORTALS.SEARCH_DID_YOU_MEAN, SearchDidYouMean)}
        </SearchProvider>
      }

    </div>
  )
}

export default App;